module.exports = __webpack_public_path__ + "static/media/ates.6e4d9554.png";